import axios from 'axios';

const apiUrl = '/api/v2/event-registrations';

export const LOOKUP_REGISTRATION_EVENT = 'LOOKUP_REGISTRATION_EVENT';
export const LOOKUP_REGISTRATION_EVENT_CLEAR =
  'LOOKUP_REGISTRATION_EVENT_CLEAR';
export const SELECT_REGISTRATION_EVENT = 'SELECT_REGISTRATION_EVENT';
export const CREATE_EVENT_REGISTRATION = 'CREATE_EVENT_REGISTRATION';
export const CREATE_BULK_EVENT_REGISTRATION = 'CREATE_BULK_EVENT_REGISTRATION';
export const FETCH_EVENT_REGISTRATIONS = 'FETCH_EVENT_REGISTRATIONS';
export const FETCH_EVENT_REGISTRATIONS_FOR_EVENT =
  'FETCH_EVENT_REGISTRATIONS_FOR_EVENT';
export const DELETE_EVENT_REGISTRATION = 'DELETE_EVENT_REGISTRATION';
export const RESET_CREATE_SUCCESS = 'RESET_CREATE_SUCCESS';

export function lookupRegistrationEvent(key) {
  const request = axios.get(
    `${apiUrl}/lookup?event_key=${encodeURIComponent(key)}`,
  );

  return {
    type: LOOKUP_REGISTRATION_EVENT,
    payload: request,
  };
}

export function clearRegistrationEvent() {
  return {
    type: LOOKUP_REGISTRATION_EVENT_CLEAR,
  };
}

export function selectRegistrationEvent(event) {
  return {
    type: SELECT_REGISTRATION_EVENT,
    payload: event,
  };
}

export function createEventRegistration(data) {
  const request = axios.post(apiUrl, data);

  return {
    type: CREATE_EVENT_REGISTRATION,
    payload: request,
  };
}

export function createBulkEventRegistration(data) {
  const request = axios.post(`${apiUrl}/bulk`, data);

  return {
    type: CREATE_BULK_EVENT_REGISTRATION,
    payload: request,
  };
}

export function fetchEventRegistrations() {
  const request = axios.get(apiUrl);

  return {
    type: FETCH_EVENT_REGISTRATIONS,
    payload: request,
  };
}

export function fetchEventRegistrationsForEvent(eventId) {
  const request = axios.get(`${apiUrl}/for-event?event_id=${eventId}`);

  return {
    type: FETCH_EVENT_REGISTRATIONS_FOR_EVENT,
    payload: request,
  };
}

export function resetCreateSuccess() {
  return { type: RESET_CREATE_SUCCESS };
}

export function deleteEventRegistration(id) {
  const request = axios.delete(`${apiUrl}/${id}`);

  return {
    type: DELETE_EVENT_REGISTRATION,
    payload: request,
    meta: { id },
  };
}
